(function (scope) {
  'use strict';

  var PACK_ORDER = ['1', '3', '6', '12'];

  function normalizePackLabel(value) {
    if (value === null || value === undefined) return null;

    var match = String(value).trim().toLowerCase().match(/^(1|3|6|12)\s*(?:-|\s)?\s*(?:pack|packs|jar|jars)?$/);
    return match && PACK_ORDER.indexOf(match[1]) !== -1 ? match[1] : null;
  }

  function asPositiveNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : null;
  }

  function calculateSavingsPercent(price, compareAtPrice) {
    var current = asPositiveNumber(price);
    var compareAt = asPositiveNumber(compareAtPrice);

    if (current === null || compareAt === null || compareAt <= current) return null;
    return Math.round(((compareAt - current) / compareAt) * 100);
  }

  function calculatePerServing(price, servings) {
    var current = asPositiveNumber(price);
    var count = asPositiveNumber(servings);

    if (current === null || count === null) return null;
    return Math.round(current / count);
  }

  function buildPackModels(variants, configByPack) {
    var variantsByPack = {};
    (Array.isArray(variants) ? variants : []).forEach(function (variant) {
      var key = normalizePackLabel(variant && (variant.optionValue || variant.title));
      if (key && !variantsByPack[key]) variantsByPack[key] = variant;
    });

    return PACK_ORDER.reduce(function (models, key) {
      var variant = variantsByPack[key];
      if (!variant) return models;

      var config = (configByPack && configByPack[key]) || {};
      models.push({
        key: key,
        variantId: variant.id,
        title: config.title || variant.title,
        badge: config.badge || '',
        supplyText: config.supplyText || '',
        servings: asPositiveNumber(config.servings),
        price: Number(variant.price),
        compareAtPrice: variant.compareAtPrice === null || variant.compareAtPrice === undefined
          ? null
          : Number(variant.compareAtPrice),
        savingsPercent: calculateSavingsPercent(variant.price, variant.compareAtPrice),
        perServing: calculatePerServing(variant.price, config.servings),
        available: Boolean(variant.available),
        image: config.image || config.icon_url || variant.image || '',
      });
      return models;
    }, []);
  }

  function selectInitialPack(packs, preferredPack) {
    var available = (Array.isArray(packs) ? packs : []).filter(function (pack) {
      return pack.available;
    });
    var preferredKey = normalizePackLabel(preferredPack);
    var preferred = available.find(function (pack) { return pack.key === preferredKey; });
    return preferred || available[0] || null;
  }

  function buildCartSubmission(pack, compactMode, sellingPlanId) {
    return {
      variantId: pack ? pack.variantId : null,
      quantity: 1,
      sellingPlanId: compactMode ? null : (sellingPlanId || null),
    };
  }

  function applyCartSubmission(form, submission) {
    if (!form || !submission) return form;

    Array.prototype.forEach.call(form.elements || [], function (control) {
      if (!control || !control.name) return;

      if (control.name === 'id') control.value = String(submission.variantId || '');
      if (control.name === 'quantity') control.value = String(submission.quantity || 1);
      if (control.name === 'selling_plan') {
        control.value = submission.sellingPlanId || '';
        control.disabled = !submission.sellingPlanId;
      }
    });

    return form;
  }

  function updateProductImage(image, imageUrl) {
    if (!image || !imageUrl) return false;

    var largeImageUrl = String(imageUrl).replace(/([?&]width=)\d+/, function (_match, prefix) {
      return prefix + '1800';
    });

    image.src = largeImageUrl;
    image.srcset = '';
    image.removeAttribute('srcset');

    if (image.hasAttribute('data-src')) image.setAttribute('data-src', largeImageUrl);
    if (image.hasAttribute('data-srcset')) image.removeAttribute('data-srcset');

    return true;
  }

  scope.LgdLandingPagePurchase = {
    normalizePackLabel: normalizePackLabel,
    calculateSavingsPercent: calculateSavingsPercent,
    calculatePerServing: calculatePerServing,
    buildPackModels: buildPackModels,
    selectInitialPack: selectInitialPack,
    buildCartSubmission: buildCartSubmission,
    applyCartSubmission: applyCartSubmission,
    updateProductImage: updateProductImage,
  };
})(globalThis);
